import { Component } from '@angular/core';
import { AuditorshipService } from 'src/shared/services/auditorship.service';
import { Unsubscriber } from '../../unsubscriber/unsubscriber.component';

// Imports Standalone
import { ReportAuditManageComponent } from "../report-audit-manage/pages/report-audit-manage.component";
import { AuditEditComponent } from "../audit-edit/pages/audit-edit.component";
import { ReactiveFormsModule, FormsModule } from '@angular/forms';

import { TableModule } from 'primeng/table';
import { ButtonModule } from 'primeng/button';
import { CardModule } from 'primeng/card';
import { FileUploadModule } from 'primeng/fileupload';
import { TagModule } from 'primeng/tag';
import { DialogModule } from 'primeng/dialog';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'app-report-audit',
    templateUrl: './report-audit.component.html',
    styleUrls: ['./report-audit.component.less'],
    imports: [
    ReportAuditManageComponent,
    AuditEditComponent,
    ReactiveFormsModule,
    DialogModule,
    FormsModule,
    TableModule,
    ButtonModule,
    CardModule,
    FileUploadModule,
    TagModule,
    TranslateModule
]
})

export class ReportAuditComponent extends Unsubscriber {
  constructor(private auditorshipService: AuditorshipService) {
    super();
  }

  ngOnInit(): void {
    this.subscriptions = this.auditorshipService.editingAudit.subscribe({
      next: (value: boolean) => {
        if (value) {
          this.isManagingAudit = false;
        } else this.isManagingAudit = true;
        this.isEditingAudit = value;
      }
    });
    this.subscriptions = this.auditorshipService.selectedAuditId.subscribe({
      next: (auditId: string) => {
        this.editedAuditId = auditId;
      }
    })
  }

  isManagingAudit = true;
  isEditingAudit = false;
  editedAuditId = '';
  isViewingDownloadList = false;

}
